/* eslint-disable */
export default {
  getFretes(state) {
    return state.fretes;
  },
  getColunasFretes(state) {
    return state.colunasFretes;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getDashboard(state) {
    return {
      fretes: state.fretes.length,
      totalNumFretes: state.totalNumFretes,
      totalNF: state.totalNF,
      pesoTotal: state.pesoTotal,
      totalFretes: state.totalFretes,
      mediaKG: state.mediaKG,
      dentroPrazo: state.dentroPrazo,
      foraPrazo: state.foraPrazo,
      totalFechados: state.totalFechados,
      totalPendentes: state.totalPendentes,
    };
  }
};
